import { useSyncExternalStore } from 'react';
import type { ProfileData } from '@aleaces/engine';
import { getProfile, getQuestResets, subscribeProfile, type QuestResets } from './profile';
import { getMusicVolume, getSfxVolume, isMuted, subscribeSettings } from './settings';
import { getToasts, subscribeToasts, type Toast } from './toast';

/** The server-synced profile, or null before the first `profile` message. */
export function useProfile(): ProfileData | null {
  return useSyncExternalStore(subscribeProfile, getProfile);
}

/** Server-authoritative quest reset times, or null before the first profile. */
export function useQuestResets(): QuestResets | null {
  return useSyncExternalStore(subscribeProfile, getQuestResets);
}

export function useMuted(): boolean {
  return useSyncExternalStore(subscribeSettings, isMuted);
}

export function useSfxVolume(): number {
  return useSyncExternalStore(subscribeSettings, getSfxVolume);
}

export function useMusicVolume(): number {
  return useSyncExternalStore(subscribeSettings, getMusicVolume);
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (fn) => subscribeToasts(() => fn()),
    getToasts,
  );
}
